<script lang="ts">
	//Type
	import type Quill from "quill";

	//Modules
	import TextEditor from "@hitit/ui/src/TextEditor";
	import sanitizeHtml from "sanitize-html";
	//Split Modules
	import { beforeUpdate, createEventDispatcher, onMount } from "svelte";

	//Props
	export let value = "";
	export let placeholder = "";
	export let lengthLimit = 100;
	export let lineLimit = 5;
	export let disabled = false;
	export let keyboard: any = {};
	export let reactiveValue = false;
	export let reactiveId = "";
	export let focusEvent = () => {};
	export let blurEvent = () => {};

	//constants
	const dispatch = createEventDispatcher();
	const options = {
		modules: {
			toolbar: null,
			keyboard,
		},
		placeholder: placeholder,
	};

	//Variables
	let div: HTMLDivElement;
	let quill: Quill;
	let copiedReactiveId = reactiveId;

	//Life cycle
	onMount(() => {
		quill = TextEditor(div, options);
		// quill.disable();
		const container = div.querySelector(".ql-editor");
		if (container === null) return;

		quill.clipboard.dangerouslyPasteHTML(value);

		quill.on("text-change", function (delta, oldDelta, source) {
			quill.root.parentNode?.dispatchEvent(
				new CustomEvent("text-change", {
					detail: {
						html: (container as HTMLDivElement).innerHTML,
						text: quill.getText(),
					},
				})
			);
		});
		container.addEventListener("focus", focusEvent);
		container.addEventListener("blur", blurEvent);
	});
	beforeUpdate(() => {
		if (copiedReactiveId !== reactiveId && quill) {
			quill.clipboard.dangerouslyPasteHTML(value);
			copiedReactiveId = reactiveId;
			quill.setSelection(value.length, value.length);
		}
	});

	//functions
	function textEditorChangeHandler(e: {
		detail: { html: string; text: string };
	}) {
		const getLines = quill.getLines();
		const textLength = quill.getText().length - getLines.length;

		if (textLength > lengthLimit) {
			quill.deleteText(lengthLimit, textLength);
		}

		if (getLines.length > lineLimit) {
			for (let i = lineLimit; i < getLines.length; i++) {
				(getLines[i].domNode as HTMLParagraphElement).remove();
			}
		}
		const innerHTML = quill.root.innerHTML;
		const sanitezed = sanitizeHtml(innerHTML, {
			allowedTags: ["p", "br"],
			allowedAttributes: {},
		});
		dispatch("UPDATE_TEXT", {
			html: sanitezed,
			text: e.detail.text,
		});
	}
	// Do
	$: quill ? quill.enable(!disabled) : undefined;
</script>

<div
	class="plainTextEditor texteditor"
	bind:this={div}
	on:text-change={textEditorChangeHandler}
/>

<style lang="scss">
	:global(.plainTextEditor .ql-clipboard) {
		display: none;
	}
</style>
